import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

/* ICONS */
import {
  FaShieldAlt,
  FaBolt,
  FaThermometerHalf,
  FaCogs
} from "react-icons/fa";

/* STYLES */
import "./Products.css";

/* ASSETS */
import finalBanner from "../../assets/finalbanner.png";
import canned1 from "../../assets/services-9.jpg";
import canned2 from "../../assets/services-10.jpg";

const CannedMotorPumps = () => {
  const products = [
    { id: 1, name: "Standard Glandless Unit", img: canned1 },
    { id: 2, name: "Hazardous Liquid Series", img: canned2 },
  ];

  return (
    <div className="cyber-root">

      {/* ================= HERO ================= */}
      <section
  className="hud-hero"
  style={{
    backgroundImage: `
      linear-gradient(
        to bottom,
        rgba(143, 182, 243, 0.65), /* light blue overlay (top) */
        rgba(214, 230, 250, 0.55), /* soft blue overlay (middle) */
        rgba(255, 255, 255, 0.75)  /* white overlay (bottom) */
      ),
      url(${finalBanner})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="hero-content">
   <motion.h1
  className="hero-main-title"
  initial={{ opacity: 0, x: -60 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 0.9, ease: "easeOut" }}
>
    SEALLESS CANNED MOTOR PUMPS
</motion.h1>

  </div>
</section>

      {/* ================= LAYOUT ================= */}
      <div className="dashboard-container">

        {/* ================= SIDEBAR ================= */}
        <aside className="sidebar-nav">
          <h3>Product Categories</h3>

          <nav className="nav-buttons">
            <Link to="/products/transformer-oil-pumps">
              Glandless Transformer Oil Pumps
            </Link>
            <Link to="/products/monoblock-pumps">
              Self-Priming Monoblock Pumps
            </Link>
            <Link className="active" to="/products/canned-motor-pumps">
              Sealless Canned Motor Pumps
            </Link>
            <Link to="/products/marine-pumps">
              Marine Centrifugal Pumps
            </Link>
            <Link to="/products/process-pumps">
              Centrifugal Process Pump
            </Link>
          </nav>
        </aside>

        {/* ================= MAIN CONTENT ================= */}
        <main className="industrial-panel">

          {/* PANEL HEADER */}
          <div className="panel-top">
            <FaShieldAlt className="cyan-icon" />
            <h2>Sealless Canned Motor Pumps</h2>
          </div>
          <br/>

          {/* DESCRIPTION */}
          <p className="company-description">
            The Canned Motor Pump is a combination of a centrifugal pump and a
            special motor connected through a one-piece assembly. The stator is
            canned in the air gap, confining the liquid in the rotor chamber. The
            pumped liquid circulates through the rotor chamber, cooling the motor
            and lubricating the sleeve bearings that support the rotor.
            <br /><br />
            These are liquid immersed motors to achieve the Glandless construction. These are suitable for low ‘NPSH’ requirements. The dynamically balanced performance ensures the defined bearing life. Bearing monitors are provided to monitor the life of the bearings.
            <br /><br />
           These are used in areas where pumping liquid is precious, gaseous liquid, hazardous liquid. These are used in application like creosotic liquid. FLOWTECH PUMPS AND MOTORS canned motor pumps are having low noise vibration in construction with sleeve bearings specifically designed for hazardous and gaseous liquids.
          </p>

          {/* TECH SPECS */}
          <div className="tech-specs">
            <div className="spec-item">
              <FaBolt className="cyan-icon" />
              <div>
                <span>POWER RANGE</span>
                <p>Up to 15 HP (Under Development up to 100 HP)</p>
              </div>
            </div>

            <div className="spec-item">
              <FaThermometerHalf className="cyan-icon" />
              <div>
                <span>TEMPERATURE RANGE</span>
                <p>−40°C to 270°C (Up to 350°C under development)</p>
              </div>
            </div>

            <div className="spec-item">
              <FaCogs className="cyan-icon" />
              <div>
                <span>DESIGN</span>
                <p>Glandless Canned Motor Pump</p>
              </div>
            </div>
          </div>

          {/* PRODUCT MODELS */}
          <section className="product-showcase">
            <h3 className="section-label">Available Models</h3>

            <div className="product-grid">
              {products.map((p) => (
                <motion.div
                  key={p.id}
                  whileHover={{ y: -8 }}
                  className="pump-card"
                >
                  <div className="img-holder">
                    <span className="pump-id">{p.id}</span>
                    <img src={p.img} alt={p.name} />
                  </div>

                  <div className="pump-details">
                    <h4>{p.name}</h4>
                                                    <Link to="/products/canned-motor-pumps" onClick={() => window.scrollTo(0, 0)}> 
  <button className="view-btn">View Datasheet</button>
</Link>
                  </div>
                </motion.div>
              ))}
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default CannedMotorPumps;
